export * from '@fhs/routing/src/routes/rewards/history';
export { default } from '@fhs/routing/src/routes/rewards/history';
